<template>
  <div class="template-status noWrap">
    <v-icon
      :color="getStatus.color"
    >
      mdi-checkbox-blank-circle
    </v-icon>
    <span>
      {{ getStatus.label }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CommunicationMessageConfigColumn',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getValue() {
      return this.value;
    },
    getLabel() {
      const { path } = this.$route;
      if (path.includes('logs')) {
        return {
          1: 'Enviar',
          2: 'Não enviar',
        };
      }
      return {
        1: 'Configurado',
        2: 'Não configurado',
      };
    },
    getStatus() {
      const value = this.getValue;
      const templateStatus = {
        1: {
          color: 'success',
          textColor: 'success',
        },
        2: {
          color: 'error',
          textColor: 'error',
        },
        3: {
          color: 'warning',
          textColor: 'error',
          label: 'Não identificado',
        },
      };

      Object.keys(this.getLabel)
        .forEach(
          (key) => {
            templateStatus[key].label = this.getLabel[key];
          },
        );

      if (typeof value !== 'boolean') {
        return templateStatus['3'];
      }

      if (value) {
        return templateStatus['1'];
      }

      return templateStatus['2'];
    },
  },
};
</script>

<style scoped>
.template-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.template-status > .v-icon {
    font-size: 0.8em;
    margin-right: 8px;
    margin-top: -0.2em;
}

</style>
